import type { Crumb } from "./Breadcrumb";
import Breadcrumb from "./Breadcrumb";

interface CategoryHeroProps {
  title: string;
  description: string;
  crumbs: Crumb[];
  icon?: string;
}

export default function CategoryHero({ title, description, crumbs, icon = "ri-fire-line" }: CategoryHeroProps) {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="px-4 py-8 md:px-8 md:py-10">
        <Breadcrumb items={crumbs} />
        <div className="mt-5 flex items-start gap-4">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className={`${icon} text-2xl`} aria-hidden="true"></i>
          </span>
          <div>
            <h1 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">{title}</h1>
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-500">{description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}